import requests from "./httpService";

const UserServices = {
  getAllUsers: async () => {
    return requests.get("/admin/user/all_users");
  },
  // getSubscriberById: async (id, body) => {
  //   return requests.get(`/admin/Subscribers/Subscriber/${id}`, body);
  // },
  searchUser: async (query) => {
    return requests.get(`/admin/user/search_all_users?q=${query}`);
},
sendMail: async (body) => {
  return requests.post("admin/users_messages/store", body);
},
getAllUser: async () => {
  return requests.get("/admin/user/all_users_table");
},
addUser: async (body) => {
  return requests.post("/admin/user/add_user", body);
},
};
export default UserServices;
